<template>
    <colored-number :value="value" threshold="100"></colored-number>
</template>

<script>
    import ColoredNumber from '@/components/Numbers/ColoredNumber'

    export default {
        components: {ColoredNumber},

        props: ['value']
    }
</script>
